import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ListBase } from '../list-base';
import { LxmDialog } from 'src/app/_helpers';
import { FileService } from 'src/app/_services';
import { appSettings } from 'src/app/app.settings';
import { AppState } from 'src/app/state/app.state';
import { LxmAppModule, UserAction } from 'src/app/enum';

@Component({
  selector: 'declarations-list',
  templateUrl: './declarations-list.component.html',
  styleUrls: ['./declarations-list.scss']
})
export class DeclarationsListComponent extends ListBase implements OnInit {

  @ViewChild('download') private _download: ElementRef;

  private _defaultColumns: string[] = ['file_name', 'file_created_at', 'file_language', 'file_created_by', 'recipients', 'actions'];

  public get columns(): string[] {
    return this._defaultColumns;
  }

  @Input() public dialogRef: any;
  @Input() public displayHeadersWhenEmpty = false;
  @Input() public softDelete = false;
  @Input() public readonly = false;

  @Input() public actionLoading = {} as any;

  @Output() public open = new EventEmitter();
  @Output() public download = new EventEmitter();
  @Output() public remove = new EventEmitter();

  public languageMap = appSettings.languages.reduce((acc, curr) => {
    acc[curr.value] = { iso3: curr.iso3.toLowerCase(), name: curr.name };
    return acc;
  }, {});

  public LxmAppModule = LxmAppModule;
  public UserAction = UserAction;

  constructor(
    private _dialog: LxmDialog,
    private _fileService: FileService,
    public appState: AppState
  ) {
    super();
  }

  public openAddFileDialog(row: any = null) {
    if (this.open.observers.length > 0) {
      this.open.emit(row);
    } else if (this.dialogRef) {
      this._dialog.open(this.dialogRef, {
        data: {
          row: row,
          dataTableRef: this.dataSource
        }
      });
    }
  }

  public async downloadDeclaration(row: any) {
    if (this.download.observers.length > 0) {
      this.download.emit(row);
    } else if (row) {
      const { fileId, fileName } = row;
      this._fileService.download(fileId);
    }
  }

  public removeDeclaration(row: any) {
    if (this.softDelete) {
      if (row.isNew) {
        const i = this.dataSource.data.indexOf(row);
        this.dataSource.data.splice(i, 1);
      } else {
        row.isDeleted = true;
      }
    } else {
      this.remove.emit(row);
    }
  }
}
